"use client";
import Button from "@/components/ui/button";

// The core AuthContext reports `user_error` when it cannot read the user/cart (network, 500); without this the
// cart and checkout pages rendered as if the cart were empty.
const LoadError = () => (
	<div role="alert" className="flex flex-col items-center gap-4 py-10 text-center">
		<p className="text-sm text-jmt-main">دریافت سبد خرید با خطا مواجه شد.</p>
		<Button type="button" color_type="primary" text="تلاش دوباره" onClick={() => window.location.reload()} className="h-10! px-4!" />
	</div>
);

export default LoadError;
